import Header from './Header';
import HeaderSimple from './HeaderSimple';

export { HeaderSimple };
export default Header;